// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__JkbX0","image":"Avatar_image__3oBwD"};